module.exports = __webpack_public_path__ + "img/chevron-right-20px-light.bde4987.svg";